<template>
  <v-btn 
    icon
    :disabled="checkForTags(task) || !$can('assignDeviceToVehicle')" 
    @click="toggleAssignmentComp(task)"
  >
    <v-icon
      color="blue"
      large
    >
      mdi-link
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'DeviceAssignment',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  methods: {
    checkForTags(task) {
      // check if there is an OTC and install tags, if there is none, the button is disabled
      if (task.task_type == 'taskinstall') {
          let hasTags = task.context.devices.length > 0 ? true : false;
          let availableTags = task.context.devices.some(tag => {
              return tag.install_tag != '';
          }); 

          return hasTags && availableTags ? false : true;
      }
      else {
          return true; 
      } 
    },
    toggleAssignmentComp(task) {
      this.$emit('toggleAssignmentComp', task);
    }
  }
}
</script>